import { SettingsFlow, RecoveryFlow, LoginFlow, RegistrationFlow, UiText } from '@ory/client';

type OryFlow = SettingsFlow | RecoveryFlow | LoginFlow | RegistrationFlow;

function isOryFlow(error: unknown): error is OryFlow {
  return (
    typeof error === 'object' &&
    error !== null &&
    'ui' in error &&
    typeof error.ui === 'object' &&
    error.ui !== null
  );
}

export function extractErrors(error: unknown): { messages: string[] } {
  if (!error) {
    return { messages: [] };
  }

  if (typeof error === 'string') {
    return { messages: [error] };
  }

  if (isOryFlow(error)) {
    const uiMessages = (error.ui.messages ?? []) as UiText[];
    const uiErrors = uiMessages.filter(m => m.type === 'error');

    const nodeErrors =
      error.ui.nodes
        ?.flatMap(node => (node.messages ?? []) as UiText[])
        .filter(m => m.type === 'error') ?? [];

    const allErrors = [...uiErrors, ...nodeErrors];
    return { messages: allErrors.map(m => m.text) };
  }

  if (error instanceof Error) {
    return { messages: [error.message] };
  }

  return { messages: ['An unexpected error occurred'] };
}
